import { nanoid } from '@reduxjs/toolkit';
import RootView from './RootView';
import type { IAlertMessage, IUserAlert } from './interface';
import { dispatchAction, getStore } from './store';
import actions from './actions';
import { constructMessage } from './util';

function alerter(): IUserAlert {
    const alert: IUserAlert = {
        renderer: RootView,
        show: function (this: IUserAlert, message: Partial<IAlertMessage>) {
            const alertHider = this.hide;
            function _defaultAction(this: IAlertMessage) {
                alertHider(this);
            }

            const newItem = constructMessage(message, {
                onAccept: _defaultAction,
                onDecline: _defaultAction,
            });

            dispatchAction(actions.showPopUp(newItem));
        },
        hide: (message: Partial<IAlertMessage>) => {
            dispatchAction(actions.hidePopUp(message));
        },
        isShowing: (message: Partial<IAlertMessage>) => {
            const store = getStore();

            const results = store
                .filter(item => item.id === message.id)
                .filter(item => item.show ?? true);

            return results.length > 0;
        },
        alert: (id: string) => getStore().filter(item => item.id === id)[0],
        update: (message: Partial<IAlertMessage> & Required<{ id: string }>) =>
            dispatchAction(actions.updatePopUp(message)),
    };

    return alert;
}

export default alerter;
